/**
 * RukuNaSrce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ErrorCode = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19 | 20 | 21 | 22 | 23 | 24 | 10000 | 10001 | 10002 | 10003 | 10004 | 10005 | 10006 | 10007 | 10008 | 10009 | 10010 | 10011 | 10012 | 10013 | 10014 | 10015 | 10016 | 10017;

export const ErrorCode = {
    UserNotFound: 0 as ErrorCode,
    EmailInUse: 1 as ErrorCode,
    IdPresentInCreate: 2 as ErrorCode,
    InvalidEmailOrPassword: 3 as ErrorCode,
    ActionForbidden: 4 as ErrorCode,
    NotFound: 5 as ErrorCode,
    PropertyNotFound: 6 as ErrorCode,
    CantReauthenticate: 7 as ErrorCode,
    PhoneNumberNotVerified: 8 as ErrorCode,
    PhoneNumberAlreadyVerified: 9 as ErrorCode,
    PhoneNumberAlreadyInUse: 10 as ErrorCode,
    PhoneNumberFormatInvalid: 11 as ErrorCode,
    InvalidOrExpiredCode: 12 as ErrorCode,
    PasswordConfirmationNotSame: 13 as ErrorCode,
    SyncRequestAlreadyExists: 14 as ErrorCode,
    AlertNotFound: 15 as ErrorCode,
    EmailNotVerified: 16 as ErrorCode,
    PromotionNotFound: 17 as ErrorCode,
    GeofenceNotFound: 18 as ErrorCode,
    CodeResendTimeout: 19 as ErrorCode,
    ChatNotFound: 20 as ErrorCode,
    PromotionsNotFound: 21 as ErrorCode,
    BrandImageNotFound: 22 as ErrorCode,
    BrandImageIsActive: 23 as ErrorCode,
    UserNotVerified: 24 as ErrorCode,
    ValidationErrors: 10000 as ErrorCode,
    Required: 10001 as ErrorCode,
    NotValidEmailAddress: 10002 as ErrorCode,
    MinLength: 10003 as ErrorCode,
    MaxLength: 10004 as ErrorCode,
    Length: 10005 as ErrorCode,
    GreaterThanOrEqual: 10006 as ErrorCode,
    GreaterThan: 10007 as ErrorCode,
    LessThanOrEqual: 10008 as ErrorCode,
    LessThan: 10009 as ErrorCode,
    NotEqual: 10010 as ErrorCode,
    Predicate: 10011 as ErrorCode,
    Regex: 10012 as ErrorCode,
    Equal: 10013 as ErrorCode,
    ExactLength: 10014 as ErrorCode,
    Between: 10015 as ErrorCode,
    Empty: 10016 as ErrorCode,
    Invalid: 10017 as ErrorCode
};

